// O nome do arquivo é cadastrado sem extensão e pode ter pontos ("Lei 8.112"): sem
// o sufixo, o navegador salva sem .pdf ou com a extensão errada e o arquivo não abre.
export const pdfFileName = (name: string) =>
	/\.pdf$/i.test(name) ? name : `${name}.pdf`
